/* Streetwear redesign (every page): product rails + size filter, search suggestions, back-to-top button.
   The hero globe lives in rg-globe.js. No dependencies. */
(function () {
  function initRail(rail) {
    if (rail.dataset.rgReady) return;
    rail.dataset.rgReady = '1';
    var track = rail.querySelector('[data-rg-track]');
    if (!track) return;
    var prev = rail.querySelector('[data-rg-prev]');
    var next = rail.querySelector('[data-rg-next]');
    var bar = rail.querySelector('[data-rg-progress]');

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar) {
        var visible = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        bar.style.width = Math.min(100, visible * 100) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * (1 / visible - 1) * 100 : 0) + '%)';
      }
    }
    function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    var chips = rail.querySelectorAll('[data-rg-size]');
    if (chips.length) {
      var cards = track.querySelectorAll('[data-sizes]');
      chips.forEach(function (chip) {
        var size = chip.getAttribute('data-rg-size');
        if (size !== 'all') {
          var count = 0;
          cards.forEach(function (c) { if ((',' + c.dataset.sizes + ',').indexOf(',' + size + ',') > -1) count++; });
          var sup = chip.querySelector('sup');
          if (sup) sup.textContent = count;
          if (!count) chip.hidden = true;
        }
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', c === chip); });
          cards.forEach(function (c) {
            c.hidden = size !== 'all' && (',' + c.dataset.sizes + ',').indexOf(',' + size + ',') === -1;
          });
          track.scrollLeft = 0;
          update();
        });
      });
    }
    update();
  }

  /* ---------- Search suggestions: shown when the header search opens, before anything is typed ---------- */
  // Edit these to change the "Popular searches" buttons.
  var SUGGESTIONS = [['Jordan 4', '/collections/jordan'], ['Corteiz', '/collections/corteiz'], ['Chrome Hearts', '/collections/chrome-hearts'],
    ['Denim Tears', '/collections/denim-tears'], ['Sp5der', '/collections/sp5der'], ['Broken Planet', '/collections/broken-planet'],
    ['Ralph Lauren', '/collections/ralph-lauren'], ['Hoodies', '/collections/hoodies'], ['Footwear', '/collections/footwear'], ['Lanvin', '/collections/lanvin']];
  var TRENDING_URL = '/collections/best-sellers/products.json?limit=24';

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(amount) {
    var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '{{amount}}';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }
  function initSearchSuggest() {
    var container = document.querySelector('.site-header__search-container');
    var input = container && container.querySelector('.site-header__search-input');
    var bar = container && container.querySelector('.site-header__search');
    if (!input || !bar || container.querySelector('.rg-suggest')) return;
    var panel = document.createElement('div');
    panel.className = 'rg-suggest';
    panel.hidden = true;
    panel.innerHTML = '<div class="rg-suggest__inner"><div><p class="rg-suggest__label">Popular searches</p><div class="rg-suggest__chips">' +
      SUGGESTIONS.map(function (s) { return '<a class="rg-pill" href="' + s[1] + '">' + esc(s[0]) + '</a>'; }).join('') +
      '</div></div><div><p class="rg-suggest__label">Trending now</p><div class="rg-suggest__products"></div></div></div>';
    bar.parentNode.insertBefore(panel, bar.nextSibling);
    var grid = panel.querySelector('.rg-suggest__products');
    var loaded = false;

    function loadTrending() {
      if (loaded) return;
      loaded = true;
      fetch(TRENDING_URL).then(function (res) { return res.json(); }).then(function (data) {
        var items = data.products.filter(function (p) {
          return p.images.length && p.variants.some(function (v) { return v.available; });
        }).slice(0, 4);
        grid.innerHTML = items.map(function (p) {
          var src = p.images[0].src;
          var price = Math.min.apply(null, p.variants.map(function (v) { return parseFloat(v.price); })).toFixed(2);
          return '<a class="rg-suggest__product" href="/products/' + p.handle + '">' +
            '<img src="' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="' + esc(p.title) + '" loading="lazy" width="300" height="375">' +
            '<span>' + esc(p.title) + '</span><span class="rg-suggest__price">' + money(price) + '</span></a>';
        }).join('');
      }).catch(function () { loaded = false; });
    }
    function update() {
      var show = !input.value.trim();
      panel.hidden = !show;
      if (show) loadTrending();
    }
    input.addEventListener('focus', update);
    input.addEventListener('input', update);
    document.querySelectorAll('.js-search-header').forEach(function (btn) {
      btn.addEventListener('click', function () { setTimeout(update, 60); });
    });
  }
  /* ---------- Back-to-top button with scroll-progress ring ---------- */
  function initBackToTop() {
    if (document.querySelector('.rg-top')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rg-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg class="rg-top__ring" viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="31"/></svg>' +
      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M8 14V3M3.5 7.5L8 3l4.5 4.5"/></svg>';
    document.body.appendChild(btn);
    var ring = btn.querySelector('circle');
    var ticking = false;
    function update() {
      ticking = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var y = window.scrollY || window.pageYOffset;
      btn.classList.toggle('is-visible', y > 600);
      ring.style.strokeDashoffset = 195 * (1 - (max > 0 ? Math.min(1, y / max) : 0));
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    btn.addEventListener('click', function () {
      var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    });
    update();
  }

  /* ---------- Logo intro: RELOADGCC appears centred, then glides into the header (first visit per session) ---------- */
  // window.rgIntro resolves when the intro is over (or skipped); rg-globe.js waits on it before growing the earth.
  var EASE = 'cubic-bezier(.22, 1, .36, 1)';
  function wait(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }
  function runIntro() {
    var root = document.documentElement;
    var logo = document.querySelector('.site-header__logo-link');
    if (!root.classList.contains('rg-intro-pending') || !logo || !document.body.animate) {
      root.classList.remove('rg-intro-pending');
      return Promise.resolve();
    }
    var overlay = document.createElement('div');
    overlay.className = 'rg-intro';
    overlay.setAttribute('aria-hidden', 'true');
    var word = document.createElement('span');
    word.className = 'rg-intro__word';
    word.textContent = logo.textContent.trim();
    overlay.appendChild(word);
    document.body.appendChild(overlay);
    root.classList.remove('rg-intro-pending'); // the overlay now covers the page instead
    logo.style.opacity = '0';

    var finish = function () { logo.style.opacity = ''; overlay.remove(); };
    return word.animate([
      { opacity: 0, transform: 'scale(.86)', filter: 'blur(8px)' },
      { opacity: 1, transform: 'scale(1)', filter: 'blur(0)' }
    ], { duration: 900, easing: EASE, fill: 'forwards' }).finished
      .then(function () { return wait(350); })
      .then(function () {
        var from = word.getBoundingClientRect(), to = logo.getBoundingClientRect();
        var scale = to.width / from.width;
        var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
        var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
        return Promise.all([
          word.animate([{ transform: 'translate(0, 0) scale(1)' }, { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + scale + ')' }],
            { duration: 1000, easing: EASE, fill: 'forwards' }).finished,
          overlay.animate([{ backgroundColor: 'rgba(0,0,0,1)' }, { backgroundColor: 'rgba(0,0,0,0)' }],
            { duration: 1000, easing: EASE, fill: 'forwards' }).finished
        ]);
      })
      .then(finish, finish);
  }
  window.rgIntro = new Promise(function (resolve) { window.rgIntroResolve = resolve; });

  /* ---------- Keep the homepage hero clear of the header Motion overlays on top of it ---------- */
  function syncHeaderHeight() {
    var wrap = document.querySelector('.header-wrapper');
    if (!wrap) return;
    function set() {
      if ((window.scrollY || window.pageYOffset) > 5) return; // a sticky header changes size once scrolled; measure at the top only
      document.documentElement.style.setProperty('--rg-header-h', Math.ceil(wrap.offsetHeight) + 'px');
    }
    set();
    window.addEventListener('resize', set);
    window.addEventListener('load', set);
  }
  function initAll(root) {
    (root || document).querySelectorAll('[data-rg-rail]').forEach(initRail);
  }
  function boot() {
    syncHeaderHeight(); initAll(); initBackToTop(); initSearchSuggest();
    runIntro().then(window.rgIntroResolve, window.rgIntroResolve);
    // Safety net: never leave the globe hidden if its script fails to load
    setTimeout(function () { document.querySelectorAll('.rg-globe').forEach(function (g) { g.classList.add('is-in'); }); }, 6000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme editor: re-init when a section is added or re-rendered
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();